import React from 'react';

interface IAuthSlotProps {
    hasForm?: boolean;
    children?: React.ReactNode;
}

const AuthSlot: React.FC<IAuthSlotProps> = ({ hasForm, children }) => (
    <div className={`content-page__auth${hasForm ? ' content-page__auth--form' : ''}`}>{children}</div>
);

export default AuthSlot;
